export const path = "integracao/csv-corpo-docente";
